import { fg } from '@atlaskit/platform-feature-flags';

import type { Trait, TraitsForContext } from '../types';

const parseBooleanTrait = (trait: Trait | undefined): boolean => {
	if (!trait) {
		return false;
	}
	if (typeof trait.value === 'boolean') {
		return trait.value;
	}
	if (typeof trait.value === 'string') {
		return trait.value === 'true';
	}
	return false;
};

export const getSiteTraitValues = (traits: Trait[]): TraitsForContext => {
	if (traits.length === 0) {
		return {
			automationUsage: 0,
			lastAutomationFreeLimitBreachDate: null,
			isSiteEligibleToServcoUplift: false,
			isEligibleForJsmStandardToPremium: false,
			isEligibleForJswStandardToPremium: false,
			isEligibleForJpdStandardToPremium: false,
			isEligibleForConfluenceStandardToPremium: false,
		};
	}

	const automationUsageTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_current_usage',
	);
	const lastAutomationFreeLimitBreachDateTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_usage_latest_breach_date',
	);

	const servcoUpliftTrait = traits.find(
		(trait) => trait.name === 'is_site_eligible_to_servco_uplift',
	);

	const isUpsellFgOn = fg('standard-to-premium-ea-refactor');

	const jsmUpsellTrait = isUpsellFgOn
		? traits.find((trait) => trait.name === 'segment_jsm_was_paid_tenant_5d_ago_siteid')
		: undefined;
	const jswUpsellTrait = isUpsellFgOn
		? traits.find((trait) => trait.name === 'segment_jsw_was_paid_tenant_5d_ago_siteid')
		: undefined;
	const jpdUpsellTrait = isUpsellFgOn
		? traits.find((trait) => trait.name === 'segment_jpd_was_paid_tenant_5d_ago_siteid')
		: undefined;
	const confluenceUpsellTrait = isUpsellFgOn
		? traits.find((trait) => trait.name === 'segment_confluence_was_paid_tenant_5d_ago_siteid')
		: undefined;

	const automationUsage =
		automationUsageTrait &&
		automationUsageTrait.value !== undefined &&
		!isNaN(Number(automationUsageTrait.value))
			? Number(automationUsageTrait.value)
			: 0;

	const lastAutomationFreeLimitBreachDate =
		lastAutomationFreeLimitBreachDateTrait &&
		typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' &&
		!isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value))
			? new Date(lastAutomationFreeLimitBreachDateTrait.value)
			: null;

	const isSiteEligibleToServcoUplift = Boolean(
		servcoUpliftTrait && typeof servcoUpliftTrait.value === 'boolean' && servcoUpliftTrait.value,
	);

	return {
		automationUsage,
		lastAutomationFreeLimitBreachDate,
		isSiteEligibleToServcoUplift,
		isEligibleForJsmStandardToPremium: parseBooleanTrait(jsmUpsellTrait),
		isEligibleForJswStandardToPremium: parseBooleanTrait(jswUpsellTrait),
		isEligibleForJpdStandardToPremium: parseBooleanTrait(jpdUpsellTrait),
		isEligibleForConfluenceStandardToPremium: parseBooleanTrait(confluenceUpsellTrait),
	};
};
